import { ReactComponent as IconDelete } from "@/assets/svgs/Delete.svg"
import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconSuccess, ReactComponent as IconSuccessPistop } from '@/assets/svgs/icon-account-setting-tick.svg'
import { ReactComponent as IconBuilding } from '@/assets/svgs/icon-building.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconError } from '@/assets/svgs/icon-error-message-exclamation.svg'
import { ReactComponent as IconPitstop } from '@/assets/svgs/icon-pitstop.svg'
import { ReactComponent as IconRemoveDataElement } from '@/assets/svgs/icon-remove-data-element.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg'
import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure'
import CardCopyContributor from '@/components/CardCopyContributor'
import DropdownContributor from "@/components/DropdownContributor/index"
import InputSuffixIcon from '@/components/InputSuffixIcon'
import Modal from '@/componentsDS/Modal/Modal'
import ModalTemplate from '@/components/ModalTemplate/index'
import PopoverWithState from '@/components/PopoverWithState/index'
import Portal from '@/components/Portal'
import Toast from '@/components/Toast/index'
import { featureConstant } from "@/constants/configuration/feature"
import { EnrolmentTypes } from "@/constants/use-case/enrolment"
import useDataElementDetails from '@/hooks/use-data-elements-details/index'
import useDebounce from "@/hooks/use-debounce/index"
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page/index'
import usePitstop from "@/hooks/use-pitstop/index"
import useSystem from "@/hooks/use-sys"
import useToast from '@/hooks/use-toast/index'
import { useNavigate, useParams } from '@/lib/router-dom'
import PrincipalList from '@/pages/use-cases/components/PrincipalList/index'
import API_DATA_ELEMENTS_REQUEST from '@/services/api/dataElementsEnrolment'
import { feature } from "@/utils/feature-verifier"
import rem from '@/utils/rem'
import classname from 'classnames'
import { orderBy, uniqueId } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import Loader from 'react-loader-spinner'
import Search from '@/componentsDS/Search/index';
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index"
import useEnrolments from '@/hooks/use-enrolments'

const dataTableOptionsMenu = [{
	type: 'Revoke',
	text: 'Revoke'
}, {
	type: 'Edit',
	text: 'Edit Principal'
}]

const DataTableRowMenu = ({ visible, setVisible, item, options, onClick, ...props }) => {
	return <PopoverWithState
		visible={visible}
		setVisible={setVisible}
		placement="bottom-end"
		closable={true}
		hoverOpen={true}
		{...props}
	>
		<PopoverWithState.Trigger>
			<div data-testid="data-table-row-menu-btn" className="ellipsis-button data_table__principal_menu"><span></span></div>
		</PopoverWithState.Trigger>
		<PopoverWithState.Content>
			<div className="data_table__principal_menu__dropdown__content">
				{options?.map((option) => (
					<div data-testid={option.text} className="data_table__principal_menu__dropdown__item" id='data-table-menu-item' key={option.type}
						onClick={() => onClick(option.type, item)}
						onKeyPress={() => onClick(option.type, item)}
					>
						{option.text}
					</div>
				))}
			</div>
		</PopoverWithState.Content>
	</PopoverWithState>
}

const DataTableRow = ({ item, index, handleRevoke, onClickMenu, visibleMenu, setVisibleMenu, dataTableMenuClass }) => {
	// const [visibleMenu, setVisibleMenu] = useState(false)

	return (
		<div className="data-table__table__body__row" key={index}>
			<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy">
				<div className="data-table__table__body__content__avatar-row">
					<div
						className="data-table__table__body__content__avatar"
						style={{ backgroundImage: `url(${item?.iconUrl})` }}
					>
						{item?.iconUrl ? null : <IconBuilding />}
					</div>
					<div className="data-table__table__body__content--text">
						<div data-testid="participant-name" className="data-table__table__body__content__top">
							{item?.name}
						</div>
					</div>
				</div>
			</div>

			<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy">
				{item?.principals?.slice(0, 3)?.map((principal, index) => {
					return (<div className="data-table__table__body__content__row data-table__principals__row" key={principal?.principalId}>
						<div className="data-table__principals__row__text">{principal.principalName}</div>
						{(item?.principalCount > 3 || item?.principals?.length > 3) && index === 2 && (
							<div className="data-table__principals__row__text inline">{`+ ${(item?.principalCount || item?.principals?.length) - 3} more`}</div>
						)}
					</div>)
				})}
			</div>
			<div className={dataTableMenuClass('data-table__table__body__content')}>
				<DataTableRowMenu
					visible={visibleMenu}
					setVisible={setVisibleMenu}
					item={item}
					options={item?.principals ? dataTableOptionsMenu : [dataTableOptionsMenu[0]]}
					onClick={onClickMenu}
				/>
			</div>
		</div>
	)
}

DataTableRow.propTypes = {
	item: PropTypes.object,
	index: PropTypes.number,
	handleRevoke: PropTypes.func,
	onClickMenu: PropTypes.func,
	visibleMenu: PropTypes.bool,
	setVisibleMenu: PropTypes.func,
	dataTableMenuClass: PropTypes.func,
}

const CopyCheckbox = ({ selected, handleUpdateItemSelect, disabled }) => {
	const CheckBoxClass = classname({
		"use-case-request__checkbox": true,
		"use-case-request__checkbox--active": selected,
		"use-case-request__checkbox--disabled": disabled,
	})

	return (
		<div data-testid='checkbox-element' className={CheckBoxClass} onClick={handleUpdateItemSelect} onKeyPress={handleUpdateItemSelect}>{selected ? <IconTick /> : null}</div>
	)
}

CopyCheckbox.propTypes = {
	selected: PropTypes.bool,
	handleUpdateItemSelect: PropTypes.func,
	disabled: PropTypes.bool,
}

const PitstopList = ({ removePitstop, pitstopList, type, updateSelectedPitstopByCheckBox, updateSelectedPitstop, systems, setSelectedAgentPrincipalPitstop, setSystems, pitstopSearch, handleEditPrincipal, handleViewMorePrincipal, isOnBehalfOfPrincipal, loading }) => {
	const NonAgentPrincipalRow = ({ item, index }) => (
		<div key={uniqueId('pitstop-list')}>
			<div className="layout-data-elements__col">
				<div
					className="layout-data-elements__content__avatar"
					style={{
						backgroundImage: `url(${item?.system?.images})`,
					}}
				>
					{!item?.system?.images && <IconPitstop />}
				</div>
				<div style={{ width: "83%" }}>
					<div className="layout-data-elements__col">
						<div className="layout-data-elements__content__text">
							<div className="layout-data-elements__content__top">
								{item?.name}
							</div>
						</div>
						<div className="layout-data-elements__content__text">
							<div data-testid="remove-data-element" className="layout-data-elements__content__top-right"
								style={{ cursor: "pointer" }}
								onClick={() => removePitstop(item)}
								onKeyPress={() => removePitstop(item)}
							>
								<IconDelete />
							</div>
						</div>
					</div>
				</div>
			</div>
			{pitstopList?.find(pitem => pitem.systemId === item.id) ? "" :
				(type === EnrolmentTypes.provider && <div >
					<div className="layout-data-elements__col" key={"first" + index}>
						<div className="layout-data-elements__content__checkbox">
							<CopyCheckbox selected={item.$visibleDropdown} handleUpdateItemSelect={() => { updateSelectedPitstopByCheckBox(pitstopList[0], item, pitstopList?.length, index) }} />
						</div>
						<div style={{ width: "83%" }}>
							<div className="layout-data-elements__col">
								<div className="layout-data-elements__content__text">
									<div className="layout-data-elements__content__top">
										<span className="layout-data-elements__content__checkbox__text">Send transaction copies to Pitstop</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="layout-data-elements__col" key={"second" + index}>
						<div></div>
						<div style={{ width: "83%" }}>
							<div className="layout-data-elements__content__text">
								{pitstopList?.length === 1 && <span className="layout-data-elements__content__checkbox__text"><b>{pitstopList[0].name}</b></span>}
								{item.$visibleDropdown &&
									<div >
										{pitstopList?.length > 1 &&
											<div className="layout-data-elements__content__dropdown">
												<div className="enrolment-request__dropdown-container">
													<DropdownContributor
														full
														text={"Select"}
														options={pitstopList}
														value={item.contributorSystemId !== null ? (pitstopList?.find(pitem => pitem.id === item.contributorSystemId))?.name : "Select Pitstop"}
														submit={(option) => {
															updateSelectedPitstop(option, item, pitstopList?.length)
														}}
													/>


												</div>

											</div>}
									</div>
								}
							</div>
						</div>
					</div>
				</div>)
			}
			<hr />
		</div>
	)

	const AgentPrincipalRow = ({ item, index }) => {
		const dropdownIconClass = classname({
			'layout_data_elements__content__dropdown': true,
			'layout_data_elements__content__dropdown__open': item.$selected,
		});

		const handleOnPitstopRowClick = () => {
			let newSystem = [...systems];
			setSelectedAgentPrincipalPitstop(item)
			newSystem.forEach((item, pindex) => {
				item.$selected = !item.$selected && pindex === index
				return item
			})
			setSystems(newSystem)
		}

		const handleOnPitstopDeleteClick = (e) => {
			e.stopPropagation();
			removePitstop(item);
		}

		return <div key={uniqueId('pitstop-list')}>
			<div className="layout_data_elements__row__pitstop layout-data-elements__col"
				onClick={handleOnPitstopRowClick}
				onKeyPress={handleOnPitstopRowClick}
			>
				<div className={dropdownIconClass}>
					<IconChevronDown />
				</div>
				<div
					className="layout-data-elements__content__avatar"
					style={{
						backgroundImage: `url(${item?.system?.images})`,
					}}
				>
					{!item?.system?.images && <IconPitstop />}
				</div>
				<div className="layout-data-elements__col">
					<div className="layout-data-elements__content__text">
						<div className="layout-data-elements__content__top">
							{item?.name}
						</div>
					</div>
					<div className="layout-data-elements__content__text">
						<div data-testid="remove-data-element" className="layout-data-elements__content__top-right" style={{ cursor: "pointer" }}
							onClick={handleOnPitstopDeleteClick}
							onKeyPress={handleOnPitstopDeleteClick}
						>
							<IconDelete />
						</div>
					</div>
				</div>
			</div>

			<PrincipalList loading={loading} item={item} search={pitstopSearch} displayLimit={5} handleEditPrincipal={handleEditPrincipal} handleViewMorePrincipal={handleViewMorePrincipal} />
			<hr />
		</div>
	}

	return <>
		<hr />
		{loading ? (
			<div className="layout-data-elements__center">
				<Loader
					className="loadingSpinner__position__center"
					data- testid="loadingSpinner__position__center"
					type="ThreeDots"
					color="purple"
					height={10}
					width={15}
				/>
			</div>
		) : (<>
			{systems?.length > 0 && systems
				.map((item, index) => {
					return isOnBehalfOfPrincipal ? <AgentPrincipalRow item={item} index={index} /> : <NonAgentPrincipalRow item={item} index={index} />
				})

			}
			{type === EnrolmentTypes.provider && systems?.length > 0 && systems.filter(p => pitstopList?.findIndex(mp => mp.id === p.id) < 0).length !== 0 &&
				<div className="layout-data-elements__note">
					<span className="layout-data-elements__note__start">Note:</span>  A copy of the data element transactions will be sent to the selected pitstop when this Data Element is shared on behalf of your organization.
				</div>
			}
			{systems?.length === 0 && <div className="layout-data-elements__content__empty">No Pistop available</div>}

		</>)}
	</>
}

PitstopList.propTypes = {
	removePitstop: PropTypes.func,
	pitstopList: PropTypes.object,
	type: PropTypes.string,
	updateSelectedPitstopByCheckBox: PropTypes.func,
	updateSelectedPitstop: PropTypes.func,
	systems: PropTypes.array,
	setSelectedAgentPrincipalPitstop: PropTypes.func,
	setSystems: PropTypes.func,
	pitstopSearch: PropTypes.string,
	handleEditPrincipal: PropTypes.func,
	handleViewMorePrincipal: PropTypes.func,
	isOnBehalfOfPrincipal: PropTypes.bool,
	loading: PropTypes.bool,
}

const Page = () => {
	const [selectedContributorState, setSelectedContributorState] = useState({
		selectedContributor: [],
		isRevokeContributor: false,
		contributorConfirmHeaderText: "Enable Transaction Copy",
		contributorConfirmBodyText: "Are you sure want to enable receiving transaction copies when this data element is shared by the Data Provider on behalf of your organization?",
		contributorSuccessHeaderText: "Enable Transaction Copy",
		contributorSuccessBodyText: "You have successfully enabled receiving transaction copy for this data element."
	});
	const { items: pitstopItems, fetch: fetchPitstop } = usePitstop()
	const { items: systemItems, fetchByOrgId: fetchSystem } = useSystem()
	const { checkAgentEnrolmentExist, agentEnrolmentExist, loadingEnrolment: isLoadingAgentEnrolmentStatus } = useEnrolments();

	const isAgentPrincipalPhase2Enabled = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2)

	/*=================================================
		General
	/================================================*/

	const { goTo } = useNavigate()

	const { useCaseId, dataElementId, enrolmentType } = useParams()

	const toastType = {
		success: "success",
		error: "error"
	}

	const [pageTitle, setPageTitle] = useState()
	const [subPageTitle, setSubPageTitle] = useState()

	const type = enrolmentType.toUpperCase();

	const addParticipantOptions = useMemo(() => {
		let options = []
		if(EnrolmentTypes.consumer === type) {
			options.push({
				type: 'contributer',
				text: 'Add Contributor'
			})
		} else if (EnrolmentTypes.provider === type) {
			options.push({
				type: 'consumer',
				text: 'Add Consumer'
			})
		}
		options.push({
			type: 'agent',
			text: 'Add Agent'
		})
		return options

	}, [type])

	const isOnBehalfOfPrincipal = type === EnrolmentTypes.provideOnBehalfOfPrincipal || type === EnrolmentTypes.consumeOnBehalfOfPrincipal
	const isConsumeOrProvide = type === EnrolmentTypes.consumer || type === EnrolmentTypes.provider;

	const { breadcrumbsItems, setBreadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label:'',
				link:'/'
			},
			{
				label:'Use Cases',
				link:'/use-cases/enrolment'
			}
		],

	})

	const [updated, setUpdated] = useState('NIL')
	const [typeTitle, setTypeTitle] = useState('')
	const [tableTypeTitle, setTableTypeTitle] = useState('')
	const [pitstopType, setPitstopType] = useState('')
	const [revokeMsg, setRevokeMsg] = useState('')
	const [selectedParticipant, setSelectedParticipant] = useState('')
	const [systems, setSystems] = useState([])

	const [errorMessage, setErrorMessage] = useState(null)
	const [addParticipantDropdown, setAddParticipantDropdown] = useState(false)

	/*=================================================
		Modal
	/================================================*/

	const { visible: visibleRevokeConfirm, show: showRevokeConfirm, hide: hideRevokeConfirm } = useModal()
	const { visible: visibleDeleteConfirm, show: showDeleteConfirm, hide: hideDeleteConfirm } = useModal()
	const { visible: visibleValidateConfirm, show: showValidateConfirm, hide: hideValidateConfirm } = useModal()
	const { visible: visibleSuccessDeleteConfirm, show: showSucessDeleteConfirm, hide: hideSuccessDeleteConfirm } = useModal()
	const { visible: visibleMorePrincipal, show: showMorePrincipal, hide: hideMorePrincipal } = useModal()

	/*=================================================
		Searchbox
	/================================================*/

	const [participantSearch, setParticipantSearch] = useState('')
	const [pitstopSearch, setPitstopSearch] = useState(null)
	const debouncedPitstopSearch = useDebounce(getData, "dataFiltering");

	useEffect(() => {
		if (pitstopSearch !== null && !visibleMorePrincipal && !loadingDataElementDetail)
			debouncedPitstopSearch()
	}, [pitstopSearch, visibleMorePrincipal])

	/*=================================================
		API
	/================================================*/

	const { register, handleSubmit } = useForm()

	const { toastList, addToastMessage } = useToast()

	const { currentItem, setCurrentItem, fetchDataElementsDetail, fetchEnrolmentPrincipals, error, loading: loadingDataElementDetail } = useDataElementDetails()

	const params = {
		useCaseId,
		dataElementId,
		type: enrolmentType,
		pitstopSearch: pitstopSearch,
	}

	const [participants, setParticipants] = useState([])

	const [addMorePitstops, setAddMorePitstops] = useState(false)

	async function getData() {
		const data = await fetchDataElementsDetail(params)

		if (type === EnrolmentTypes.provider) {
			setTypeTitle('Contributing')
			setTableTypeTitle('Consumers')
			setPitstopType('Providing')
		} else if (type === EnrolmentTypes.consumer) {
			setTypeTitle('Consuming')
			setTableTypeTitle('Contributors')
			setPitstopType('Consuming')
		} else if (type === EnrolmentTypes.provideOnBehalf) {
			setTypeTitle('Providing on behalf')
			setTableTypeTitle('Contributors providing on behalf for')
			setPitstopType('Providing')
		} else if (type === EnrolmentTypes.consumeOnBehalf) {
			setTypeTitle('Consuming on behalf')
			setTableTypeTitle('Consuming on behalf of')
			setPitstopType('Consuming')
		} else if (type === EnrolmentTypes.provideOnBehalfOfPrincipal) {
			setTypeTitle(isAgentPrincipalPhase2Enabled ? 'Providing on behalf (Principal)' : 'Providing as agent')
			setTableTypeTitle('Consumers')
			setPitstopType('Providing')
		} else if (type === EnrolmentTypes.consumeOnBehalfOfPrincipal) {
			setTypeTitle(isAgentPrincipalPhase2Enabled ? 'Consuming on behalf (Principal)' : 'Consuming as agent')
			setTableTypeTitle('Contributors')
			setPitstopType('Consuming')
		}

		const pageName = data?.dataElement?.dataElementName

		setPageTitle(pageName)
		setBreadcrumbsItems(
			[
				{
					label:'',
					link:'/'
				},
				{
					label:'Use Cases',
					link:'/use-cases/enrolment'
				},
				{
					label: data?.useCase?.useCaseTitle,
					link: `/use-cases/${useCaseId}/dashboard`
				},
				{
					label: 'Data Elements Exchanged',
					link: `/use-cases/${useCaseId}/data-elements-list`
				},
				{
					label: pageName,
					link: ``
				},
			]
		)

		setUpdated(data?.modified)
		setParticipants(data?.participants || [])
		setSystems(addSelected(data?.system?.filter(obj => obj.enrolStatus === 'APPROVED')))
		setCurrentItem(data)

		let getSystems = {
			useCaseId: useCaseId,
			dataElementId: dataElementId,
			type: enrolmentType.toUpperCase(),
		};

		if (
			enrolmentType.toUpperCase() === EnrolmentTypes.provider ||
			enrolmentType.toUpperCase() === EnrolmentTypes.consumer
		) {
			getSystems = {
				...getSystems,
				of: "ALL",
			};
		}

		await fetchSystem(getSystems);
		await fetchPitstop();
	}

	useEffect(() => {
		getData()
	}, [])

	useEffect(() => {
		addToastMessage(error, toastType.error)
	}, [error])

	useEffect(() => {
		if (pitstopItems?.length > 0 && currentItem) {
			setAddMorePitstops(
				systemItems.length <= currentItem?.system.length
			)
		}
	}, [pitstopItems, currentItem])


	useEffect(() => {
		if(isConsumeOrProvide && isAgentPrincipalPhase2Enabled)
			checkAgentEnrolmentExist({
				useCaseId: useCaseId,
				dataElementId: dataElementId,
				type: type
			})
	}, [isConsumeOrProvide, isAgentPrincipalPhase2Enabled])

	const pitstopList = pitstopItems?.map((item, i) => {
		return {
			id: item.systemId,
			name: item.systemName,
			systemId: item.systemId,
			orgId: item.orgId,
			$sysOptionsVisible: false
		}
	})
	const [selectedPitstop, setSelectedPitstop] = useState('');
	const [selectedEnrolmentId, setSelectedEnrolmentId] = useState('');

	/*=================================================
		Pagination
	/================================================*/

	const [currentPage, setCurrentPage] = useState(1)
	const totalPerPage = 5
	const [participantList, setParticipantList] = useState([])
	const [totalPage, setTotalPage] = useState()
	const [totalItemCount, setTotalItemCount] = useState('')

	/*=================================================
		Sort
	/================================================*/

	const [sortConfig, setSortConfig] = useState({
		key: 'orgName',
		direction: true,
	})

	/*=================================================
		Filter Popup
	/================================================*/

	const [filterVisible, setFilterVisible] = useState()

	const { visible: visiblePitstopConfirmModal, show: showPitstopConfirmModal, hide: hidePitstopConfirmModal } = useModal()
	const { visible: visiblePitstopConfirm, show: showPitstopConfirm, hide: hidePitstopConfirm } = useModal()
	const { visible: visiblePitstopStatus, hide: hidePitstopStatus } = useModal()

	const { visible: visibleCancelCopyToContributorModal, show: showCancelCopyToContributorModal, hide: hideCancelCopyToContributorModal } = useModal()
	const { visible: visibleCancelCopyToContributorConfirm, show: showCancelCopyToContributorConfirm, hide: hideCancelCopyToContributorConfirm } = useModal()

	/*=================================================
		Request Fields
	/================================================*/

	const RequestFields = ({ data }) => {
		if (!Array.isArray(data)) {
			return ''
		}
		return data.map((item, index) => {
			return (
				<div className="container-content-item__col" key={index}>
					<span>{item.name}</span>
				</div>
			)
		})
	}

	/*=================================================
		Sort
	/================================================*/

	function handleSort(key) {
		let direction = sortConfig.direction
		if (sortConfig.key === key) {
			direction = !direction
		} else {
			direction = true
		}

		const sortDirection = direction === true ? 'asc' : 'desc'

		setSortConfig({ key, direction })

		const updatedDataElementInfo = orderBy(
			participantList,
			['name'],
			[sortDirection],
		)

		setParticipantList(updatedDataElementInfo)
	}

	/*=================================================
		Paginate
	/================================================*/

	useEffect(() => {
		if (participantSearch.trim().length > 0) {
			const updatedParticipantList = participants.filter((participant) => {
				return participant.name
					.toLowerCase()
					.includes(participantSearch.toLowerCase())
			})
			setParticipantList(updatedParticipantList)
			setTotalPage(Math.ceil(updatedParticipantList.length / totalPerPage))
			setTotalItemCount(updatedParticipantList.length)
		} else {
			const start = currentPage > 1 ? (currentPage - 1) * totalPerPage : 0
			const currentParticipantList = participants.slice(
				start,
				start + totalPerPage,
			)
			setParticipantList(currentParticipantList)
			setTotalPage(Math.ceil(participants.length / totalPerPage))
			setTotalItemCount(participants.length)
		}
	}, [currentPage, participantSearch, participants])

	function goToPrev() {
		if (currentPage === 1) {
			return
		}

		setCurrentPage((prev) => prev - 1)
	}

	function goToNext() {
		if (currentPage === totalPage) {
			return
		}

		setCurrentPage((prev) => prev + 1)
	}

	useEffect(() => {
		if (currentPage > totalPage) {
			setCurrentPage(1)
		}
	}, [participantList])

	/*=================================================
		Datatable
	/================================================*/

	function getClassName(name) {
		if (!sortConfig) {
			return
		}

		const sortConfigCheck = sortConfig.direction === true ? 'is-asc' : 'is-desc'
		return sortConfig.key === name ? sortConfigCheck : ''
	}

	function getPageStart(pageSize, pageNr) {
		return pageSize * pageNr
	}

	function getPageLabel(total, pageSize, pageNr) {
		if (participantList.length === 0) {
			return "0"
		}

		const start = Math.max(getPageStart(pageSize, pageNr), 0)
		const end = Math.min(getPageStart(pageSize, pageNr + 1), total)

		return `${start + 1} - ${end}`
	}

	function handleCurrentInput(e) {
		const value = e.target?.value === '' ? 1 : e.target.value
		const current = parseInt(value)

		if (current < 1) {
			return setCurrentPage(1)
		}

		if (current > totalPage) {
			return setCurrentPage(totalPage)
		}

		setCurrentPage(current)
	}

	const NoMessage = () => {
		if (participantSearch) {
			return (
				<div className="data-table__empty__icon">
					<IconNoMessage />
					<span>No participant found</span>
				</div>
			)
		}
		return (
			<div className="data-table__empty__icon">
				<IconNoMessage />
				<span>You have not provided any data elements</span>
			</div>
		)
	}

	const dataTableMenuClass = (addClass) => classname(
		addClass, {
		'data-table__table__body__content--end-menu': true,
	})

	const DataTable = (
		<div className="data-table__content">
			<div className="data-table__content__cols">
				<div className="data-table__content__col">
					<div className="data-table__data-element-table">
						<div className="data-table__table__head">
							<div className="data-table__table__head__row">
								<div className="data-table__table__head__row__left data-table__table__head__row__left--full-width">
									{
										feature(featureConstant.NEW_DESIGN_SYSTEM) ? (
											<div style={{maxWidth:"310px"}}>

												<Search  value={participantSearch ||""} onChange={(e) => setParticipantSearch(e.target.value)} onCancel={()=> setParticipantSearch("")}/>
											</div>

										):(

											<InputSuffixIcon
												maxWidth="310"
												placeholder="Search"
												icon={<IconSearch />}
												onChange={(e) => setParticipantSearch(e.target.value)}
												value={participantSearch}
											/>
										)
									}
								</div>
								<div className="data-table__table__head__row__right">
									{(!isAgentPrincipalPhase2Enabled && (type === EnrolmentTypes.provider || type === EnrolmentTypes.consumer || isOnBehalfOfPrincipal)) && (
										<Button
											text="Add Participants"
											disabled={systems?.length === 0}
											submit={() => goToAddParticipants()}
											data-testid="add-participant-button"
										/>
									)}
									{(isAgentPrincipalPhase2Enabled && (isOnBehalfOfPrincipal || (!agentEnrolmentExist && isConsumeOrProvide))) && (
										<Button
											text="Add Participants"
											disabled={systems?.length === 0}
											submit={() => goToAddParticipants()}
											loading={isLoadingAgentEnrolmentStatus}
											data-testid="add-participant-button"
										/>
									)}
									{isAgentPrincipalPhase2Enabled && !isLoadingAgentEnrolmentStatus && agentEnrolmentExist && isConsumeOrProvide && (
										<PopoverWithState
											setVisible={setAddParticipantDropdown}
											visible={addParticipantDropdown}
											placement="bottom-end"
											closable={true}
										>
											<PopoverWithState.Trigger>
												<Button
													addClass="agent_principal__add_participant_button"
													text="Add Participants"
													suffix={<IconChevronDown/>}
													submit={() => setAddParticipantDropdown(prev => !prev)}
													data-testid="add-participant-dropdown-button"
												/>
											</PopoverWithState.Trigger>
											<PopoverWithState.Content>
												<div className="agent_principal__add_participant__dropdown__content">
													{addParticipantOptions?.map((option) => (
														<div className="agent_principal__add_participant__dropdown__item" id='principal-id' role="none" key={option.type} onClick={() => {
															if(option.type === 'agent') {
																return goToAddParticipants(true)
															}
															goToAddParticipants()
														}}>
															{option.text}
														</div>
													))}
												</div>
											</PopoverWithState.Content>
										</PopoverWithState>

									)}
								</div>
							</div>
							<div className="data-table__table__head__row">
								<div
									className={`data-table__table__head__title data-table__table__head__title__sort-order ${getClassName(
										'orgName',
									)}`}
									id="orgName"
									onClick={(e) => handleSort('orgName')}
									onKeyPress={(e) => handleSort('orgName')}
								>
									{tableTypeTitle}{' '}
									<span className="data-table__table__head__icon__sort-order"></span>
								</div>

								<div
									className={`data-table__table__head__title`}
								>
									{participantList.some((participant) => participant.principals) ? 'Principals' : ''}
								</div>

								<div className={dataTableMenuClass('data-table__table__head__title')} />
							</div>
						</div>

						<div className="data-table__table__body data-table__data-element-body">
							{Array.isArray(participantList) && participantList?.length > 0 ? (
								participantList.map((item, index) => {
									return <DataTableRow
										item={item}
										index={item.id}
										handleRevoke={handleRevoke}
										onClickMenu={handleOnClickDataTableMenu}
										visibleMenu={item?.$visibleMenu}
										setVisibleMenu={(visible) => {
											const newParticipantList = [...participantList]
											newParticipantList.forEach((participant, pIndex) => {
												participant.$visibleMenu = (pIndex === index) && visible
												return participant
											})
											setParticipantList(newParticipantList)
										}}
										dataTableMenuClass={dataTableMenuClass}
									/>
								})
							) : (
								loadingDataElementDetail ? (
									<div className="data-table__empty" >
										<Loader
											className="loadingSpinner__position__center"
											data- testid="loadingSpinner__position__center"
											type="ThreeDots"
											color="purple"
											height={10}
											width={15}
										/>
									</div>
								) : (
									<div className="data-table__empty data-table__empty_data-element-table">
										<NoMessage />
									</div>
								)
							)}
						</div>

						<div className="data-table__table__footer">
							<div className="data-table__table__footer__row">
								<div className="data-table__table__footer__row__left">
									<div className="data-table__table__pagination">
										<input
											data-testid="pagination-input"
											className="data-table__table__pagination__page"
											type="number"
											value={currentPage}
											onChange={(e) => handleCurrentInput(e)}
											min="1"
										/>
										<span className="data-table__table__pagination__page__meta">
											{' '}
											of {totalPage || 1} pages{' '}
										</span>
										<button
											data-testid="pagination-prev"
											className="data-table__table__pagination__prev"
											onClick={() => goToPrev()}
											disabled={currentPage === 1}
										>
											<IconChevronDown />
										</button>
										<button
											data-testid="pagination-next"
											className="data-table__table__pagination__next"
											onClick={() => goToNext()}
											disabled={currentPage === totalPage}
										>
											<IconChevronDown />
										</button>
									</div>
								</div>
								<div className="data-table__table__footer__row__right">
									<div className="data-table__table__meta">
										Showing{' '}
										{getPageLabel(
											totalItemCount,
											totalPerPage,
											currentPage - 1,
										)}{' '}
										of{' '}
										{participantList.length === 0 && participantSearch.length > 0
											? participants.length
											: totalItemCount || 0}{' '}
										entries
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)

	/*=================================================
		Add/Edit/Remove Pitstop
	/================================================*/

	function goToAddPitstop() {
		goTo(`/use-cases/${useCaseId}/pitstop/${dataElementId}/${enrolmentType}`);
	}

	/*=================================================
		Navigate
	/================================================*/

	function goToAddParticipants(agent) {
		if (type === EnrolmentTypes.provider) {
			if(isAgentPrincipalPhase2Enabled && agent) {
				return goTo(`/use-cases/${useCaseId}/${dataElementId}/add-consumer?agent_flow=consuming_agent`)
			}
			goTo(`/use-cases/${useCaseId}/${dataElementId}/add-consumer`)
		} else if (type === EnrolmentTypes.consumer) {
			if(isAgentPrincipalPhase2Enabled && agent) {
				return goTo(`/use-cases/${useCaseId}/${dataElementId}/add-provider?agent_flow=providing_agent`)
			}
			goTo(`/use-cases/${useCaseId}/${dataElementId}/add-provider`)
		} else if (type === EnrolmentTypes.provideOnBehalfOfPrincipal) {
			goTo(`/use-cases/${useCaseId}/${dataElementId}/add-consumer?onbehalfofprincipal=${EnrolmentTypes.provideOnBehalfOfPrincipal.toLowerCase()}`)
		} else if (type === EnrolmentTypes.consumeOnBehalfOfPrincipal) {
			goTo(`/use-cases/${useCaseId}/${dataElementId}/add-provider?onbehalfofprincipal=${EnrolmentTypes.consumeOnBehalfOfPrincipal.toLowerCase()}`)
		}
	}

	/*=================================================
		Revoke Functions
	/================================================*/

	function handleRevoke(participant) {
		setSelectedParticipant(participant)

		if (type === EnrolmentTypes.provider) {
			setRevokeMsg(
				`${participant.name} will no longer be able to receive ${currentItem.dataElement.dataElementName} data from you. `,
			)
		} else if (type === EnrolmentTypes.consumer) {
			setRevokeMsg(
				`${participant.name} will no longer be able to provide ${currentItem.dataElement.dataElementName} data to you. `,
			)
		} else if (type === EnrolmentTypes.provideOnBehalf) {
			setRevokeMsg(
				`You will no longer be able to provide ${currentItem.dataElement.dataElementName} data on behalf of ${participant.name}. `,
			)
		} else if (type === EnrolmentTypes.consumeOnBehalf) {
			setRevokeMsg(
				`You will no longer be able to consume ${currentItem.dataElement.dataElementName} data on behalf of ${participant.name}. `,
			)
		} else if (isAgentPrincipalPhase2Enabled && type === EnrolmentTypes.consumeOnBehalfOfPrincipal) {
			setRevokeMsg(
				`You will no longer be able to consume ${currentItem.dataElement.dataElementName} data on behalf of principals from ${participant.name}. `,
			)
		} else if (isAgentPrincipalPhase2Enabled && type === EnrolmentTypes.provideOnBehalfOfPrincipal) {
			setRevokeMsg(
				`You will no longer be able to provide ${currentItem.dataElement.dataElementName} data on behalf of principals to ${participant.name}. `,
			)
		} else if (isOnBehalfOfPrincipal) {
			setRevokeMsg(
				`Are you sure you want to Revoke data element access for ${participant.name}, principals will no longer able to access ${currentItem.dataElement.dataElementName} as well.`
			)
		}

		showRevokeConfirm()
	}

	async function revokeSubscription() {
		const payload = {
			type: type,
			organizationId: selectedParticipant.id,
			dataElementId: dataElementId,
			useCaseId: useCaseId,
		}

		if (selectedParticipant?.principals?.length) {
			payload['subscriptionPrincipals'] = selectedParticipant.principals.map(s => ({ principalId: s.principalId }))
		}

		const [error, result] = await API_DATA_ELEMENTS_REQUEST.update("REVOKED", payload)

		if (error) {
			hideRevokeConfirm()
			return addToastMessage(error?.message, toastType.error)
		}

		if(isAgentPrincipalPhase2Enabled) {
			addToastMessage(`You have successfully revoked the access to ${currentItem?.dataElement?.dataElementName} for ${selectedParticipant?.name}`, toastType.success)
		} else {
			addToastMessage(`You have revoked the data request.`, toastType.success)
		}

		getData()

		hideRevokeConfirm()
	}

	/*=================================================
		Verify password
	/================================================*/

	const inputClass = classname({
		'input--error': error
	})

	async function verifyUserHandler({ password }) {
		if (password === "") {
			return setErrorMessage("Required")
		}

		const payload = {
			type: type,
			dataElementId: dataElementId,
			useCaseId: useCaseId,
			password: password
		}

		const [errorDeleteDataElement, responseDeleteDataElement] = await API_DATA_ELEMENTS_REQUEST.remove(payload)

		if (errorDeleteDataElement) {
			return addToastMessage(errorDeleteDataElement, toastType.error)
		}

		hideValidateConfirm()
		showSucessDeleteConfirm()
	}

	function removePitstop(item) {
		setSelectedPitstop(item.name)
		setSelectedEnrolmentId(item.enrolmentId)
		showPitstopConfirmModal()
	}

	async function removePitstopConfirm() {
		const [error, result] = await API_DATA_ELEMENTS_REQUEST.removePitstop(selectedEnrolmentId)

		if (error) {
			return addToastMessage(error?.message, toastType.error)
		}

		hidePitstopConfirmModal()
		showPitstopConfirm()
		getData();
	}

	async function removeCancelCopyToDistributorConfirm() {

		const [error, result] = await API_DATA_ELEMENTS_REQUEST.updateContributer(selectedContributorState?.selectedContributor)

		if (error) {
			return addToastMessage(error?.message, toastType.error)
		}


		hideCancelCopyToContributorModal()
		showCancelCopyToContributorConfirm()
		getData()

	}

	function cancelCopyToDistributorModal() {
		hideCancelCopyToContributorModal()
		getData()
	}


	function updateSelectedPitstopByCheckBox(option, item, pitstopLength, index) {

		const newSystem = [...systems];
		newSystem[index].$visibleDropdown = !newSystem[index].$visibleDropdown;
		setSystems(newSystem)

		let newContributor = [{
			"enrolmentId": item.enrolmentId,
			"contributorSystemId": option.systemId,
			"contributorOrgId": option.orgId,
			"ccToContributor": item.$visibleDropdown
		}]
		let newSelectedContributorState;

		if (pitstopLength === 1) {
			if (item.$visibleDropdown) {
				newSelectedContributorState = {
					selectedContributor: newContributor,
					isRevokeContributor: false,
					contributorConfirmHeaderText: "Enable Transaction Copy",
					contributorConfirmBodyText: "Are you sure want to enable receiving transaction copies when this data element is shared by the Data Provider on behalf of your organization?",
					contributorSuccessHeaderText: "Enable Transaction Copy",
					contributorSuccessBodyText: "You have successfully enabled receiving transaction copy for this data element."
				};
			} else {
				newSelectedContributorState = {
					selectedContributor: newContributor,
					isRevokeContributor: true,
					contributorConfirmHeaderText: "Disable Transaction Copy",
					contributorConfirmBodyText: "Are you sure want to disable receiving transaction copies when this data element is shared by the Data Provider on behalf of your organization?",
					contributorSuccessHeaderText: "Disable Transaction Copy",
					contributorSuccessBodyText: "Successfully disabled. You will no longer receive transaction copy for this data element."
				};
			}

			setSelectedContributorState(newSelectedContributorState);
			showCancelCopyToContributorModal()
		} else if (item.contributorSystemId != null) {
			newSelectedContributorState = {
				selectedContributor: newContributor,
				isRevokeContributor: true,
				contributorConfirmHeaderText: "Disable Transaction Copy",
				contributorConfirmBodyText: "Are you sure want to disable receiving transaction copies when this data element is shared by the Data Provider on behalf of your organization?",
				contributorSuccessHeaderText: "Disable Transaction Copy",
				contributorSuccessBodyText: "Successfully disabled. You will no longer receive transaction copy for this data element."
			};

			setSelectedContributorState(newSelectedContributorState);
			showCancelCopyToContributorModal()
		}
	}

	function updateSelectedPitstop(option, item, pitstopLength) {
		let newContributor = [{
			"enrolmentId": item.enrolmentId,
			"contributorSystemId": option.systemId,
			"contributorOrgId": option.orgId,
			"ccToContributor": item.$visibleDropdown
		}]
		let newSelectedContributorState;

		if (item.$visibleDropdown && item.contributorSystemId !== null) {
			let selectedPitstop = (pitstopList?.find(pitem => pitem.id === option.systemId))?.name
			newSelectedContributorState = {
				selectedContributor: newContributor,
				isRevokeContributor: false,
				contributorConfirmHeaderText: "Receive Transaction Copy",
				contributorConfirmBodyText: "Are sure want to save the changes?",
				contributorSuccessHeaderText: "Receive Transaction Copy",
				contributorSuccessBodyText: `You have successfully changed pitstop to receive transaction copies to pitstop ${selectedPitstop}`
			};
		} else if (item.$visibleDropdown && item.contributorSystemId === null) {
			newSelectedContributorState = {
				selectedContributor: newContributor,
				isRevokeContributor: false,
				contributorConfirmHeaderText: "Enable Transaction Copy",
				contributorConfirmBodyText: "Are you sure want to enable receiving transaction copies when this data element is shared by the Data Provider on behalf of your organization?",
				contributorSuccessHeaderText: "Enable Transaction Copy",
				contributorSuccessBodyText: "You have successfully enabled receiving transaction copy for this data element."
			};
		} else {
			newSelectedContributorState = {
				selectedContributor: newContributor,
				isRevokeContributor: true,
				contributorConfirmHeaderText: "Disable Transaction Copy",
				contributorConfirmBodyText: "Are you sure want to disable receiving transaction copies when this data element is shared by the Data Provider on behalf of your organization?",
				contributorSuccessHeaderText: "Disable Transaction Copy",
				contributorSuccessBodyText: "Successfully disabled. You will no longer receive transaction copy for this data element."
			};
		}

		setSelectedContributorState(newSelectedContributorState);
		showCancelCopyToContributorModal()
	}

	function addSelected(array) {
		array = array?.map(item => { return { ...item, $visibleDropdown: item.ccToContributor } })

		if (!array?.some(item => item.$selected) && array?.length > 0 && isOnBehalfOfPrincipal) {
			array[0].$selected = true;
		}
		return array
	}

	/*=================================================
		Agent Principal
	/================================================*/

	const [selectedAgentPrincipalPitstop, setSelectedAgentPrincipalPitstop] = useState({
		id: '',
		name: '',
		principals: []
	})

	useEffect(() => {
		setSelectedAgentPrincipalPitstop(systems?.find(s => s?.$selected))
	}, [systems])

	const handleEditPrincipal = (systemId) => {
		goTo(`/use-cases/${useCaseId}/data-elements/${dataElementId}/${enrolmentType}/system/${systemId}/edit-principal`, {
			enrolmentId: selectedAgentPrincipalPitstop?.enrolmentId,
			dataElementName: currentItem?.dataElement.dataElementName,
			useCaseName: currentItem?.useCase.useCaseTitle,
			pitstopName: selectedAgentPrincipalPitstop?.name,
		})
	}

	function handleOnClickDataTableMenu(type, participant) {
		if (type === dataTableOptionsMenu[0].type) {
			handleRevoke(participant)
		} else if (type === dataTableOptionsMenu[1].type) {
			goTo(`/use-cases/${useCaseId}/${dataElementId}/${enrolmentType}/participant/${participant?.id}/edit-principal`, {
				dataElementName: currentItem?.dataElement.dataElementName,
				useCaseName:  currentItem?.useCase.useCaseTitle,
				isRemoveOnly: false,
				organisationName: participant?.name,
			})
		}
	}

	async function handleViewMorePrincipal(item) {
		const enrolmentPrincipals = await fetchEnrolmentPrincipals(item.enrolmentId)
		setSelectedAgentPrincipalPitstop({ ...item, principals: enrolmentPrincipals })
		showMorePrincipal();
	}

	const renderRemovePitstopConfirmModalMessage = () => {
		const message = [];
		let fromType = <b>{typeTitle} {pageTitle}</b>;
		let isConsumeOrProvide;

		if (type === EnrolmentTypes.provideOnBehalfOfPrincipal) {
			fromType = <><b>{"Provide On Behalf (Principal)"}</b>{" for "}<b>{pageTitle}</b></>;
			isConsumeOrProvide = 'provide';
		} else if (type === EnrolmentTypes.consumeOnBehalfOfPrincipal) {
			fromType = <><b>{"Consume On Behalf (Principal)"}</b>{" for "}<b>{pageTitle}</b></>;
			isConsumeOrProvide = 'consume';
		}
		message.push(<p>Are you sure you would like to remove <b>{selectedPitstop}</b> from {fromType}?</p>);

		if (isOnBehalfOfPrincipal) {
			message.push(<p>{`You will not be able to ${isAgentPrincipalPhase2Enabled ? isConsumeOrProvide : 'consume'} on behalf of all the identified Principal(s) for this configuration.`}</p>);
		}

		return message;
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
					<div className="title-header__date-element-type">{typeTitle}</div>
				</div>
				<div className="title-header__right">
					<PopoverWithState visible={filterVisible} setVisible={setFilterVisible} options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10], }, }] }} hoverOpen={true} closable={true}>
						<PopoverWithState.Trigger>
							<div data-testid="removeDataElement-btn" className="ellipsis-button"><span></span></div>
						</PopoverWithState.Trigger>
						<PopoverWithState.Content>
							<div className="title-header__column__additional-menu">
								<div data-testid="removeDataElement-confirmBtn" title="Remove Data Element" className={`title-header__column__additional-menu__item ${isAgentPrincipalPhase2Enabled ? 'title-header__column__additional-menu__item--error': ''}`}
									onClick={() => {
										showDeleteConfirm()
										setFilterVisible(false)
									}}
								>
									<span>Remove Data Element</span>
								</div>
							</div>
						</PopoverWithState.Content>
					</PopoverWithState>
				</div>
			</div >

			<hr />

			{
				<div className="layout-data-elements">
					<div className="layout-data-elements__left">
						<div className="layout-data-elements__table">{DataTable}</div>
						<div className="layout-data-elements__block layout-data-elements__pitstop">
							<div className="layout-data-elements__header">
								<div className="layout-data-elements__header__text">
									Data Fields
								</div>
							</div>
							<div className="layout-data-elements__left__cols">
								<div className="layout-data-elements-details__left__col">
									<div className="layout-data-elements__header__text">
										Required
									</div>
									<RequestFields data={currentItem?.requiredFields || []} />
								</div>
								<div className="layout-data-elements-details__left__col">
									<div className="layout-data-elements__header__text">
										Optional
									</div>
									<RequestFields data={currentItem?.optionalFields || []} />
								</div>
							</div>
						</div>
					</div>

					<div className="layout-data-elements__right">
						<div className="layout-data-elements__right__top">
							<div className="layout-data-elements__block">
								<div className="layout-data-elements__header layout-data-elements__header__divide">
									<div className="layout-data-elements__header__text">
										{pitstopType} Pitstops
									</div>
									<div className="layout-data-elements__header__text">
										<Button ghost submit={() => goToAddPitstop()} disabled={addMorePitstops} text="Add" />
									</div>
								</div>
								<div className="layout-data-elements__body--scrollable">
									{
										feature(featureConstant.NEW_DESIGN_SYSTEM) ? (
											<div style={{maxWidth:'310px'}}>
												<Search  value={pitstopSearch}
												placeholder={"Search" + (isOnBehalfOfPrincipal ? " Pitstop or Principal" : "")}
												onChange={(e) => setPitstopSearch(e.target.value)}
												onCancel={()=> setPitstopSearch("")}
												/>
											</div>
										):(

											<InputSuffixIcon
												maxWidth="310"
												placeholder={"Search" + (isOnBehalfOfPrincipal ? " Pitstop or Principal" : "")}
												icon={<IconSearch />}
												onChange={(e) => setPitstopSearch(e.target.value)}
												value={pitstopSearch}
											/>
										)
									}
									<div className="layout-data-elements__cols">
										<PitstopList
											removePitstop={removePitstop}
											pitstopList={pitstopList}
											type={type}
											updateSelectedPitstopByCheckBox={updateSelectedPitstopByCheckBox}
											updateSelectedPitstop={updateSelectedPitstop}
											systems={systems}
											setSelectedAgentPrincipalPitstop={setSelectedAgentPrincipalPitstop}
											setSystems={setSystems}
											pitstopSearch={pitstopSearch}
											handleEditPrincipal={handleEditPrincipal}
											handleViewMorePrincipal={handleViewMorePrincipal}
											isOnBehalfOfPrincipal={isOnBehalfOfPrincipal}
											loading={loadingDataElementDetail}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="layout-data-elements__right__bottom">
							<div className="layout-data-elements__block">
								<div className="layout-data-elements__header">
									<div className="layout-data-elements__header__text">
										Attachments
									</div>
								</div>
								{currentItem?.attachmentFields}
							</div>
						</div>
					</div>
				</div>
			}

			{/* Revoke Access */}
			<ModalTemplate
				addClass='layout_data_element__modal__revoke_access'
				visible={visibleRevokeConfirm}
				hide={hideRevokeConfirm}
				show={showRevokeConfirm}
				title="Revoke Access"
				rightFooterAction={
					<Button
						round
						text="Confirm"
						submit={() => {
							revokeSubscription()
							hideRevokeConfirm()
						}}
					/>
				}
				leftFooterAction={<Button ghost round text="Cancel" submit={() => hideRevokeConfirm()} />}
				message={
					<div style={{ fontSize: rem(14), textAlign: 'center' }}>
						{revokeMsg}
						<br />
						<b>Are you sure you want to proceed?</b>
					</div>
				}
			/>

			{/* Remove Data Element Modal */}
			<Modal visible={visibleDeleteConfirm} variant="medium" close={hideDeleteConfirm}>
				<CardConfigure  >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--error'}>
											<IconRemoveDataElement />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											<span className="t--red">
												Remove Data Element
											</span>
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ fontSize: rem(14), textAlign: 'center' }}>
								{
									`Are you sure you would like to remove your configurations to ${tableTypeTitle} for ${pageTitle}?
									You will not be able to exchange it with participants until you reconfigure it in the future.`
								}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								className="button--ghost"
								style={{ width: rem(80), marginLeft: rem(10) }}
								text="Continue"
								submit={() => {
									hideDeleteConfirm()
									showValidateConfirm()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{/* Validate */}
			<Modal visible={visibleValidateConfirm} variant="medium" close={hideValidateConfirm}>
				<CardConfigure  >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--error'}>
											<IconRemoveDataElement />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											<span className="t--red">
												Remove Data Element
											</span>
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<form id="verifyUser" onSubmit={handleSubmit(verifyUserHandler)}>
								<div className="account-setting-box__modal__col__email">
									<div className="account-setting-box__modal__desc" >To continue, please verify your identity</div>
									<div style={{ marginTop: rem(6) }}>
										<input name="password" className={inputClass} type="password" placeholder="Enter current password" ref={register({ required: true })} />
										{error && (
											<div className="t--required account-setting-box__modal__error">
												<div><IconError /></div>
												<div>{error}</div>
											</div>
										)}
									</div>
								</div>
							</form>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								style={{ width: rem(80), marginLeft: rem(10) }}
								text="Confirm"
								form="verifyUser"
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{/* Success */}
			<Modal visible={visibleSuccessDeleteConfirm} variant="medium" close={() => {
								hideSuccessDeleteConfirm()
								goTo(-1)
							}}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--error'}>
											<IconRemoveDataElement />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											<span className="t--red">
												Remove Data Element
											</span>
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ fontSize: rem(14), textAlign: 'center' }}>
								<div className='modal__content__success'>
									<IconSuccess />
								</div>
								{
									`${pageTitle} has been removed.`
								}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								className="button--ghost"
								style={{ width: rem(80), marginLeft: rem(10) }}
								text="Close"
								submit={() => {
									hideSuccessDeleteConfirm()
									goTo(-1)
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{/* Remove Pitstop Confirmation Modal */}
			<Modal visible={visiblePitstopConfirmModal} variant="medium" close={hidePitstopConfirmModal}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
										Remove Pitstop
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div data-testid="remove-msg" style={{ fontSize: rem(14), textAlign: 'center' }}>
								{renderRemovePitstopConfirmModalMessage()}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								className="button__set-min-width"
								style={{ width: rem(96) }}
								text="Confirm"
								submit={() => {
									removePitstopConfirm()
								}}
							/>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{/* Remove Pitstop Success */}
			<Modal visible={visiblePitstopConfirm} variant="medium" close={hidePitstopConfirm}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Remove Pitstop
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ textAlign: "center" }}><IconSuccessPistop width={40} height={40} /></div>
							<div style={{ fontSize: rem(14), textAlign: 'center', marginTop: rem(10) }}>
								<b>{selectedPitstop}</b> has been removed. Organisations that were exchanging the data element with you will be notified.
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<button className='button--no-background button__set-min-width' onClick={() => hidePitstopConfirm()}>
								Close
							</button>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={visiblePitstopStatus} variant="medium" close={hidePitstopStatus}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Add Pitstop
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ fontSize: rem(16), textAlign: 'center', marginTop: rem(10) }}>
								There are no pitstops to be added.
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<button className='button--no-background button__set-min-width' onClick={() => hidePitstopStatus()}>
								Close
							</button>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList} />


			<Modal visible={visibleCancelCopyToContributorModal} variant="medium" close={cancelCopyToDistributorModal}>
				<CardCopyContributor>
					<CardCopyContributor.Header>
						<CardCopyContributor.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											<span className={selectedContributorState?.isRevokeContributor ? "contributor__revoke" : ""}>{selectedContributorState?.contributorConfirmHeaderText}</span>
										</div>
									</div>
								</div>
							</div>
						</CardCopyContributor.Header.Title>
					</CardCopyContributor.Header>
					<CardCopyContributor.Body>
						<CardCopyContributor.Body.Col>
							<div data-testid="remove-msg" style={{ fontSize: rem(14), textAlign: 'center' }}>
								{selectedContributorState?.contributorConfirmBodyText}
							</div>
						</CardCopyContributor.Body.Col>
					</CardCopyContributor.Body>
					<CardCopyContributor.Footer>
						<CardCopyContributor.Footer.Right>
							<button className='button--no-background button__set-min-width' onClick={() => cancelCopyToDistributorModal()}>
								Cancel
							</button>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
							<Button
								className="button__set-min-width"
								style={{ width: rem(96) }}
								text="Confirm"
								submit={() => {
									removeCancelCopyToDistributorConfirm()
								}}
							/>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
						</CardCopyContributor.Footer.Right>
					</CardCopyContributor.Footer>
				</CardCopyContributor>
			</Modal>

			<Modal visible={visibleCancelCopyToContributorConfirm} variant="medium" close={hideCancelCopyToContributorConfirm}>
				<CardCopyContributor>
					<CardCopyContributor.Header>
						<CardCopyContributor.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											<span className={selectedContributorState?.isRevokeContributor ? "contributor__revoke" : ""}>{selectedContributorState?.contributorSuccessHeaderText}</span>
										</div>
									</div>
								</div>
							</div>
						</CardCopyContributor.Header.Title>
					</CardCopyContributor.Header>
					<CardCopyContributor.Body>
						<CardCopyContributor.Body.Col>
							<div style={{ textAlign: "center" }}><IconSuccessPistop width={40} height={40} /></div>
							<div style={{ fontSize: rem(14), textAlign: 'center', marginTop: rem(10) }}>
								{selectedContributorState?.contributorSuccessBodyText}
							</div>
						</CardCopyContributor.Body.Col>
					</CardCopyContributor.Body>
					<CardCopyContributor.Footer>
						<CardCopyContributor.Footer.Right>
							<button className='button--no-background button__set-min-width' onClick={() => hideCancelCopyToContributorConfirm()}>
								Close
							</button>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
						</CardCopyContributor.Footer.Right>
					</CardCopyContributor.Footer>
				</CardCopyContributor>
			</Modal>

			{/* View More Pincipal */}
			<ModalTemplate
				addClass=''
				visible={visibleMorePrincipal}
				hide={hideMorePrincipal}
				show={showMorePrincipal}
				title={selectedAgentPrincipalPitstop?.name}
				icon={<div
					className="layout-data-elements__content__avatar"
					style={{
						backgroundImage: `url(${selectedAgentPrincipalPitstop?.images})`,
					}}
				>
					{!selectedAgentPrincipalPitstop?.images && <IconPitstop />}
				</div>}
				rightFooterButtonText={"Close"}
				message={<div>
					<div>
						<InputSuffixIcon
							placeholder="Search Principal"
							icon={<IconSearch />}
							onChange={(e) => setPitstopSearch(e.target.value)}
							value={pitstopSearch}
						/>
					</div>
					<PrincipalList loading={loadingDataElementDetail} item={selectedAgentPrincipalPitstop} search={pitstopSearch} displayLimit={0} open={true} handleEditPrincipal={handleEditPrincipal} handleViewMorePrincipal={handleViewMorePrincipal} />
				</div>}
			/>
		</>
	)
}

export default Page
